import { PreserveProfitLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/PreserveProfitLine';
import { PreserveProfitTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/PreserveProfitTacticPanel';
import { AddPreserveProfitTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddPreserveProfitTacticPanel';
import { PreserveProfitWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/PreserveProfitModule/wrapper/PreserveProfitWrapper';
import PreserveProfitDocs from '../../../../components/forms/tradeplans/documentation/PreserveProfitDocumentation';
import PreserveProfitModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/PreserveProfitModule';
import { PreserveProfitData } from './preserveProfitData';
import { validatePreserveProfit } from './validatePreserveProfit';

export const PreserveProfit = {
  //data class
  dataStore: PreserveProfitData,

  //string constants
  name: 'PRESERVE_PROFIT',
  tacticLabel: 'Preserve Profit',
  addTacticLabel: 'Add Preserve Profit',
  category: 'Exit',

  // components
  tradePlanFormModule: PreserveProfitModule,
  tacticPanel: PreserveProfitTacticPanel,
  addTacticPanel: AddPreserveProfitTacticPanel,
  wrapper: PreserveProfitWrapper,
  chartSoftOrderComponent: PreserveProfitLine,
  documentation: PreserveProfitDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validatePreserveProfit,
};
